import { inject, Injectable } from '@angular/core';
import { AppRoutes } from '@core/routes/route.paths';
import { AppService } from '@core/services/app.service';
import { UserService } from '@core/services/user/user.service';
import { SubMenu } from '@shared/model/menu-item.type';

@Injectable({ providedIn: 'root' })
export class CustomerMenuService {
  private readonly userService = inject(UserService);
  private readonly appService = inject(AppService);

  getMenu(): SubMenu {
    return {
      root: { label: 'clients', routerLink: AppRoutes.Customers.root },
      items: [
        {
          label: 'sub-menu-customers.group',
          routerLink: AppRoutes.Customers.root,
        },
        {
          label: 'sub-menu-customers.account',
          routerLink: AppRoutes.Customers.Account,
        },
        {
          label: 'sub-menu-customers.create',
          routerLink: AppRoutes.Customers.Create,
          show: () => !this.userService.isSupport() && this.appService.clientLinkExists(),
        },
        {
          label: 'sub-menu-customers.url-access',
          routerLink: AppRoutes.Customers.UrlAccess,
        },
      ],
    };
  }
}
